import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import PieChart from 'react-simple-pie-chart';
import InlineSVG from 'svg-inline-react';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import _ from 'lodash';
import Linkify from 'react-linkify';
import renderHTML from 'react-render-html';

import TaskList from '../TaskList';
import classes from './Activity.scss';
import caret from '../../assets/ic_caret.svg';
import icTasks from '../../assets/ic-tasks.svg';
import icFiles from '../../assets/ic-files.svg';
import icParticipants from '../../assets/ic-participants.svg';
import { getLocalizedActivityStrings } from '../../models/Activity';
import ContactCard from '../ContactCard/ContactCard';

export class Activity extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: false,
      activeTab: 'participants',
    };
  }

  handleExpand = e => {
    if (
      e.target.tagName !== 'A' &&
      e.target.className !== 'noexpand' &&
      e.target.className !== 'noexpand active'
    ) {
      this.setState({ expanded: !this.state.expanded });
    }
  };

  renderSidebarTheme = (activity, extraInfo) => {
    let notes = null;

    if (
      this.state.expanded &&
      typeof activity.notes !== 'undefined' &&
      activity.notes !== null &&
      activity.notes.length
    ) {
      notes = (
        <HTMLEllipsis
          unsafeHTML={activity.notes}
          maxLine="3"
          ellipsis="..."
          basedOn="letters"
          className={classes.notes}
        />
      );
    }

    const cssClass = this.state.expanded
      ? `${classes.activitySidebar} ${classes.activityExpanded} ${classes.isOpen}`
      : `${classes.activitySidebar} ${classes.isClosed}`;

    const tabs = [];
    const activeTab = this.state.activeTab; // used to preselect a tab if there is none in state

    if (
      typeof activity.persons !== 'undefined' &&
      typeof activity.staff !== 'undefined' &&
      activity.persons.length + activity.staff.length
    ) {
      tabs.push(
        <span
          key="sidebar_activity_tab_participants"
          className={
            this.state.activeTab === 'participants'
              ? 'noexpand active'
              : 'noexpand'
          }
          onClick={() => {
            this.setState({ expanded: true, activeTab: 'participants' });
          }}
        >
          <InlineSVG src={icParticipants} />
          {activity.persons.length + activity.staff.length} Teilnehmer
        </span>,
      );

      // activeTab = (!activeTab) ? 'participants' : activeTab;
    }

    if (typeof activity.tasks !== 'undefined' && activity.tasks.length) {
      tabs.push(
        <span
          key="sidebar_activity_tab_tasks"
          className={
            this.state.activeTab === 'tasks' ? 'noexpand active' : 'noexpand'
          }
          onClick={() => {
            this.setState({ expanded: true, activeTab: 'tasks' });
          }}
        >
          <InlineSVG src={icTasks} />
          {activity.tasks.length} Aufgaben
        </span>,
      );

      // check if possible tab is already set, if not, set it.
      // activeTab = (!activeTab) ? 'tasks' : activeTab;
    }

    if (typeof activity.files !== 'undefined' && activity.files.length) {
      tabs.push(
        <span
          key="sidebar_activity_tab_files"
          className={
            this.state.activeTab === 'files' ? 'noexpand active' : 'noexpand'
          }
          onClick={() => {
            this.setState({ expanded: true, activeTab: 'files' });
          }}
        >
          <InlineSVG src={icFiles} />
          {activity.files.length} Dateien
        </span>,
      );

      // activeTab = (!activeTab) ? 'files' : activeTab;
    }

    // if (this.state.activeTab !== activeTab) {
    //   this.setState({ activeTab });
    // }

    let tabContent = null;
    if (this.state.expanded) {
      if (activeTab === 'tasks') {
        tabContent = <TaskList tasks={this.props.tasks} />;
      } else if (activeTab === 'files') {
        tabContent = <span>Dateien</span>;
      } else if (activeTab === 'participants') {
        const participants = [];

        _.forOwn(this.props.staff, value => {
          participants.push(
            <ContactCard
              name={`${value.name} (M)`}
              avatar={value.avatar}
              key={`contactcard_${value.id}`}
              type="staff"
              displayType="small"
              id={value.id}
            />,
          );
        });

        _.forOwn(this.props.persons, value => {
          participants.push(
            <ContactCard
              name={`${value.name} (K)`}
              avatar={value.avatar}
              key={`contactcard_${value.id}`}
              type="person"
              displayType="small"
              id={value.id}
            />,
          );
        });

        tabContent = (
          <div className={classes.participantsList}>{participants}</div>
        );
      }
      tabContent = <div className={classes.tabContent}>{tabContent}</div>;
    }

    const tabsContainer = tabs.length ? (
      <div className={classes.tabs}>{tabs}</div>
    ) : null;
    tabContent = tabs.length ? tabContent : null;

    const date = extraInfo.startDateValid ? (
      <span>
        {extraInfo.startDate} · {extraInfo.startTime}
        <br />
      </span>
    ) : null;
    const caretHtml =
      tabs.length || (activity.notes && activity.notes.length) ? (
        <InlineSVG
          src={caret}
          className="pointer"
          alt="Mehr Infos ein/ausblenden"
        />
      ) : null;
    return (
      <section className={cssClass} onClick={e => this.handleExpand(e)}>
        <div className={classes.head}>
          <Link to={`/activity/${activity.id}`}>{activity.title}</Link>
          {caretHtml}
        </div>
        <div className={classes.meta}>
          {date}
          <span>{extraInfo.communicationString}</span>
        </div>
        {notes}
        {tabsContainer}
        {tabContent}
      </section>
    );
  };

  renderTodayTheme = (activity, extraInfo) => {
    const cssClass = this.state.expanded
      ? `${classes.activitySidebar} ${classes.activityExpanded} ${classes.isOpen}`
      : `${classes.activitySidebar} ${classes.isClosed}`;

    // if (this.state.activeTab !== activeTab) {
    //   this.setState({ activeTab });
    // }

    const participants = [];

    _.forOwn(this.props.staff, value => {
      participants.push(
        <ContactCard
          name={`${value.name} (M)`}
          avatar={value.avatar}
          key={`contactcard_${value.id}`}
          type="staff"
          displayType="small"
          id={value.id}
        />,
      );
    });

    const date = extraInfo.startDateValid ? (
      <span>
        {extraInfo.startDate} · {extraInfo.startTime}
        <br />
      </span>
    ) : null;
    return (
      <section className={cssClass} onClick={e => this.handleExpand(e)}>
        <div className={classes.head}>
          <Link to={`/activity/${activity.id}`}>{activity.title}</Link>
        </div>
        <div className={classes.meta}>
          {date}
          <span>{extraInfo.communicationString}</span>
        </div>
      </section>
    );
  };

  render() {
    const activity = this.props.activity;
    const extraInfo = getLocalizedActivityStrings(activity);
    const openClass = this.state.expanded ? classes.open : classes.closed; // const isOpen = this.state.expanded ? classes.isOpen : classes.isClosed;
    const toggleClass = this.state.expanded
      ? `${classes.toggle} ${classes.open}`
      : classes.toggle;
    const serviceTypeName =
      activity.service_type === null ||
      typeof activity.service_type === 'undefined'
        ? ''
        : activity.service_type.name;

    if (this.props.displayMode === 'today') {
      return this.renderTodayTheme(activity, extraInfo);
    }
    if (this.props.displayMode === 'sidebar') {
      return this.renderSidebarTheme(activity, extraInfo);
    }
    return (
      <section
        className={`${classes.activityList}`}
        key={`activity_${activity.id}`}
      >
        <div>
          <h2>
            <Link to={`/activity/${activity.id}`}>{activity.title}</Link>
          </h2>
          <div className="row">
            <div className="col-xs-12 col-sm-3">
              {extraInfo.communication}
              <br />
              {extraInfo.communication_direction}
            </div>
            <div className="col-xs-12 col-sm-3">
              {extraInfo.startDate}
              <br />
              {extraInfo.startTime} - {extraInfo.endTime}
            </div>
            <div className="col-xs-12 col-sm-3">{serviceTypeName}</div>
            <div className="col-xs-12 col-sm-1">
              {activity.tasks ? activity.tasks.length : null}
              <PieChart
                slices={[
                  {
                    color: '#64dc14',
                    value: 80,
                  },
                  {
                    color: '#fff',
                    value: 20,
                  },
                ]}
              />
            </div>
            <div className="col-xs-12 col-sm-2 text-right">
              <span
                className={toggleClass}
                onClick={() => {
                  this.setState({ expanded: !this.state.expanded });
                }}
              >
                ›
              </span>
            </div>
          </div>
          <div className="row">
            <div className={`col-xs-12 ${openClass}`}>
              <Linkify>
                <p>{renderHTML(activity.notes)}</p>
              </Linkify>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
Activity.propTypes = {
  activity: PropTypes.object.isRequired,
  tasks: PropTypes.object,
  staff: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  persons: PropTypes.object,
  displayMode: PropTypes.string,
};
Activity.defaultProps = {
  tasks: {},
  staff: {},
  persons: {},
  displayMode: 'standard',
};
export default Activity;



// WEBPACK FOOTER //
// ./src/components/Activity/Activity.js